import { IconName } from '@core/user-interface-legacy';

import { AutomationConditionDataValue } from './automation-triggers.types';

export enum AutomationConditionType {
  CandidateHired = 'candidate_hired',
  CandidateHasTask = 'candidate_has_task',
  CandidateTasksCompleted = 'candidate_tasks_completed',
  CandidateOverdue = 'candidate_overdue',
  CandidateHasNote = 'candidate_has_note',
  CandidateEventOrganizer = 'candidate_event_organizer',
  CandidatePreferredLocation = 'candidate_preferred_location',
  CandidateTags = 'candidate_tags',
  CandidateEventInterviewersInclude = 'candidate_event_interviewers_include',
  CandidateTaskAssigneesInclude = 'candidate_task_assignees_include',
  CandidateSourceTags = 'candidate_source_tags',
  CandidateOrigin = 'candidate_origin',
  CandidateMovedFromStage = 'candidate_moved_from_stage',
  CandidateStartDate = 'candidate_start_date',
  CandidateTaskDueDate = 'candidate_task_due_date',
  CandidateEventDate = 'candidate_event_date',
  CandidateEvaluationScore = 'candidate_evaluation_score',
  CandidateStage = 'candidate_stage',
  CandidateAllEvaluationAreCompleted = 'candidate_all_evaluation_are_completed',
  JobLocation = 'offer_location',
  JobDepartment = 'offer_department',
  JobRecruiter = 'offer_recruiter',
  JobHiringManager = 'offer_hiring_manager',
  JobWorkModel = 'offer_work_model',
  JobCreator = 'offer_creator',
  JobPreviousStatus = 'offer_previous_status',
}

export type AutomationCondition = {
  name: string;
  type: AutomationConditionType;
  iconName: IconName;
  data: Array<{
    name: string;
    selectedOption?: {
      label: string;
      value: AutomationConditionDataValue;
    };
    selectedOptions?: Array<{
      label: string;
      value: AutomationConditionDataValue;
    }>;
  }>;
};

export type AutomationDescriptionCondition = {
  type: AutomationConditionType | null;
  data: Array<{
    name: string;
    selectedOption?: {
      label: string;
      value: AutomationConditionDataValue;
    };
    selectedOptions?: Array<{
      label: string;
      value: AutomationConditionDataValue;
    }>;
  }>;
};

export type AutomationConditionDateConfig = {
  timeFrame: string | null;
  timeFrameValue: string | null;
  within: string | null;
  period: string | null;
  dateFrom: string | null;
  dateTo: string | null;
  date: string | null;
};
